import { Select } from 'antd';
import { educationParallels, educationShifts } from 'entities/education-class';
import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppSelect } from 'shared/UI/UIKit/Select';
import { AppText } from 'shared/UI/UIKit/Text';
import { AppCheckbox } from 'shared/UI/UIKit/Checkbox';
import type { AppFormInstance } from 'shared/UI/UIKit/Form';
import styles from './EducationClassForm.module.scss';

interface EducationClassFormProps {
  form: AppFormInstance;
  creationMode?: 'single' | 'multiple';
}

export const EducationClassForm = ({ form, creationMode }: EducationClassFormProps) => {
  return (
    <AppForm
      form={form}
      initialValues={{
        shift: educationShifts[0].value,
      }}
    >
      <AppFormItem rules={formRules.required} label="Параллель" name="parallel">
        <AppSelect options={educationParallels} placeholder="Выберите параллель" />
      </AppFormItem>
      {creationMode === 'multiple' ? (
        <AppFormItem
          label="Литеры"
          name="litera"
          rules={[{ required: true, message: 'Введите хотя бы одну литеру' }]}
        >
          <Select
            mode="tags"
            open={false}
            placeholder="Введите литеры"
            tokenSeparators={[',', ' ']}
            maxTagCount="responsive"
          />
        </AppFormItem>
      ) : (
        <AppFormItem rules={formRules.required} label="Литера" name="litera">
          <AppInput placeholder="Введите литеру" />
        </AppFormItem>
      )}
      <AppFormItem rules={formRules.required} label="Смена" name="shift">
        <AppSelect options={educationShifts} placeholder="Выберите смену" />
      </AppFormItem>

      <AppFormItem name="includeSaturday" valuePropName="checked">
        <AppCheckbox>
          <AppText className={styles.includeSaturday}>Класс учится в субботу</AppText>
        </AppCheckbox>
      </AppFormItem>

      <AppFormItem name="saturdayMorningShift" valuePropName="checked">
        <AppCheckbox>
          <AppText className={styles.includeSaturday}>Класс учится в субботу в 1 смену</AppText>
        </AppCheckbox>
      </AppFormItem>
    </AppForm>
  );
};
